import { Component, OnInit } from '@angular/core';
declare var $;

@Component({
  selector: 'app-author',
  templateUrl: './author.component.html',
  styleUrls: ['./author.component.css']
})
export class AuthorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  toggleSidenav(){
    $('.text').toggle(280);
    $('.menu').toggleClass('width240');
    $('.menu').toggleClass('width90');
    $('.main').toggleClass('marginLft70');
    $('.leftArrow').toggleClass('rightArrow');
    $('.rightArrowAlign').toggleClass('leftArrowAlign');
    $('.submenu-body').toggleClass('submneu-nopadding');
  }


  toggleMenuSub(){
    $('.subArrow').toggleClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
  }

  toggleMenuCommu(){
    $('.commuArrow').toggleClass("commuArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
  }

  toggleMenuPortal(){
    $('.portalArrow').toggleClass("portalArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
  }

  toggleMenuContent(){
    $('.contentAdminArrow').toggleClass("contentArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
  }

  toggleMenuAuthor(){
    $('.gameAuthArrow').toggleClass("gameAuthArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/author/author.component.ts